import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { cva, type VariantProps } from 'class-variance-authority';

const textAreaVariants = cva(
  'field-sizing-content h-auto min-h-20 w-full min-w-108 overflow-hidden rounded-sm bg-ui-field02 px-3 py-2 text-[14px] whitespace-pre-wrap text-text-primary placeholder:text-text-placeholder read-only:bg-ui-field01 read-only:text-text-secondary read-only:hover:border-border-primary read-only:focus-visible:border read-only:focus-visible:border-border-primary read-only:focus-visible:outline-none disabled:border-border-disabled disabled:bg-action-disabledBackground disabled:text-text-disabled02 disabled:placeholder:text-action-disabled01 disabled:focus-visible:border disabled:focus-visible:outline-none data-[resize=both]:resize data-[resize=horizontal]:resize-x data-[resize=none]:resize-none data-[resize=vertical]:resize-y',

  {
    variants: {
      color: {
        default:
          'border border-border-primary hover:border-action-focusBorder focus-visible:border-transparent-main focus-visible:outline-2 focus-visible:outline-action-focusBorder',
        warning:
          'border-2 border-warning-main focus-visible:border-warning-main focus-visible:outline-none disabled:border',
        error:
          'border-2 border-error-main focus-visible:border-error-main focus-visible:outline-none disabled:border',
      },
    },
    defaultVariants: {
      color: 'default',
    },
  },
);
export type TextareaProps = React.ComponentProps<'textarea'> &
  VariantProps<typeof textAreaVariants> & {
    resize?: 'none' | 'both' | 'horizontal' | 'vertical';
  };

function Textarea({ className, resize = 'none', ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      maxLength={props.maxLength}
      data-resize={resize}
      className={cn(
        textAreaVariants({ color: props.color ?? 'default' }),
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
